/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationStatistics } from './OrganizationStatistics';
import {
    OrganizationStatisticsFromJSON,
    OrganizationStatisticsFromJSONTyped,
    OrganizationStatisticsToJSON,
    OrganizationStatisticsToJSONTyped,
} from './OrganizationStatistics';
import type { OrganizationContent } from './OrganizationContent';
import {
    OrganizationContentFromJSON,
    OrganizationContentFromJSONTyped,
    OrganizationContentToJSON,
    OrganizationContentToJSONTyped,
} from './OrganizationContent';
import type { OrganizationLinks } from './OrganizationLinks';
import {
    OrganizationLinksFromJSON,
    OrganizationLinksFromJSONTyped,
    OrganizationLinksToJSON,
    OrganizationLinksToJSONTyped,
} from './OrganizationLinks';
import type { OrganizationVisual } from './OrganizationVisual';
import {
    OrganizationVisualFromJSON,
    OrganizationVisualFromJSONTyped,
    OrganizationVisualToJSON,
    OrganizationVisualToJSONTyped,
} from './OrganizationVisual';

/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    type: OrganizationTypeEnum | null;
    /**
     * 
     * @type {OrganizationContent}
     * @memberof Organization
     */
    content: OrganizationContent;
    /**
     * 
     * @type {OrganizationLinks}
     * @memberof Organization
     */
    links: OrganizationLinks;
    /**
     * 
     * @type {OrganizationVisual}
     * @memberof Organization
     */
    visual: OrganizationVisual;
    /**
     * 
     * @type {OrganizationStatistics}
     * @memberof Organization
     */
    statistics: OrganizationStatistics;
}


/**
 * @export
 */
export const OrganizationTypeEnum = {
    Company: 'company',
    NonProfit: 'non-profit',
    Patron: 'patron'
} as const;
export type OrganizationTypeEnum = typeof OrganizationTypeEnum[keyof typeof OrganizationTypeEnum];


/**
 * Check if a given object implements the Organization interface.
 */
export function instanceOfOrganization(value: object): value is Organization {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('visual' in value) || value['visual'] === undefined) return false;
    if (!('statistics' in value) || value['statistics'] === undefined) return false;
    return true;
}

export function OrganizationFromJSON(json: any): Organization {
    return OrganizationFromJSONTyped(json, false);
}

export function OrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'slug': json['slug'],
        'type': json['type'],
        'content': OrganizationContentFromJSON(json['content']),
        'links': OrganizationLinksFromJSON(json['links']),
        'visual': OrganizationVisualFromJSON(json['visual']),
        'statistics': OrganizationStatisticsFromJSON(json['statistics']),
    };
}

export function OrganizationToJSON(json: any): Organization {
    return OrganizationToJSONTyped(json, false);
}

export function OrganizationToJSONTyped(value?: Organization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'slug': value['slug'],
        'type': value['type'],
        'content': OrganizationContentToJSON(value['content']),
        'links': OrganizationLinksToJSON(value['links']),
        'visual': OrganizationVisualToJSON(value['visual']),
        'statistics': OrganizationStatisticsToJSON(value['statistics']),
    };
}

